import React, { useRef, useEffect } from 'react';
import { View, StyleSheet, Dimensions, Platform } from 'react-native';
import * as echarts from 'echarts/core';
import { LineChart, BarChart } from 'echarts/charts';
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent
} from 'echarts/components';
import { SVGRenderer, CanvasRenderer } from 'echarts/renderers';

// 仅在非web环境下导入WebView
let WebView;
if (Platform.OS !== 'web') {
  WebView = require('react-native-webview').WebView;
}

// 注册必要的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  BarChart,
  CanvasRenderer,
  SVGRenderer
]);

const ECharts = ({ option, height, width }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (Platform.OS === 'web' && chartRef.current) {
      const chart = echarts.init(chartRef.current);
      chart.setOption(option);

      // 处理窗口大小变化
      const resizeChart = () => {
        chart.resize();
      };
      window.addEventListener('resize', resizeChart);

      return () => {
        window.removeEventListener('resize', resizeChart);
        chart.dispose();
      };
    }
  }, [option, chartRef]);

  // Web平台渲染
  if (Platform.OS === 'web') {
    return (
      <div 
        ref={chartRef} 
        style={{
          width: width || '100%',
          height: height || 300,
          backgroundColor: 'transparent'
        }}
      />
    );
  }

  // React Native 移动平台渲染
  const injectedJavaScript = `
    (function() {
      var myChart = echarts.init(document.getElementById('main'));
      myChart.setOption(${JSON.stringify(option)});
      window.addEventListener('resize', function() {
        myChart.resize();
      });
    })();
    true;
  `;

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta http-equiv="content-type" content="text/html; charset=utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">
        <style type="text/css">
          html, body, #main {
            height: 100%;
            margin: 0;
            padding: 0;
            width: 100%;
          }
        </style>
        <script src="https://fastly.jsdelivr.net/npm/echarts@5/dist/echarts.min.js"></script>
      </head>
      <body>
        <div id="main"></div>
      </body>
    </html>
  `;

  return (
    <View style={[styles.container, { height, width }]}>
      <WebView
        style={styles.webView}
        source={{ html }}
        injectedJavaScript={injectedJavaScript}
        originWhitelist={['*']}
        scrollEnabled={false}
        bounces={false}
        javaScriptEnabled={true}
        domStorageEnabled={true}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'transparent',
  },
  webView: {
    flex: 1,
    backgroundColor: 'transparent',
  },
});

export default ECharts; 